<template>
  <div class="select-wrapper" @click.stop="showOptions = true">
    <div ref="select">
      <slot name="select"></slot>
    </div>
    <div v-show="lastShow" :style="styles" class="options">
      <slot name="options"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TpSelect',
  props: {
    visible: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      showOptions: false
    }
  },
  computed: {
    lastShow() {
      return this.visible === null ? this.showOptions : this.visible
    },
    styles() {
      return {
        top: this.showOptions ? `${this.$refs.select.offsetHeight}px` : 0
      }
    }
  },
  watch: {
    showOptions(newVal) {
      this.$emit('selectChange', newVal)
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
    this.startListener()
  },
  beforeDestroy() {
    this.stopListener()
  },
  methods: {
    startListener() {
      const _this = this
      document.addEventListener('click', () => {
        _this.showOptions = false
      })
    },
    stopListener() {
      const _this = this
      document.removeEventListener('click', () => {
        _this.showOptions = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrapper {
  position: relative;
  .options {
    z-index: 1000;
    position: absolute;
    width: 100%;
  }
}
</style>
